import createDebug from 'debug';

export const TOS = createDebug('TOS');
